module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/3@2x_0899cda7fe0df25acf9792444d23e83d.png";